import React from "react";

const NavigationContext = React.createContext({
  isContacting: [],
  isMobile: [],
  setIsMobile: () => {},
  setIsContacting: () => {},
  showImages: [],
  setShowImages: () => {},
});

export default NavigationContext;
